import { useEffect, useState, useCallback } from "react";
import {
  fetchEmpleadoByCUIL,
  getAllEmpleados,
  updateEstado,
} from "../services/empleados.api";
import { useToast } from "../../../../../Hooks/UseToast";
import moment from "moment";

export const useEmpleados = (search, rowsPerPage, page) => {
  // Lógica para manejar empleados
  const [empleados, setEmpleados] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { showToast, Toast } = useToast();

  const getEmpleados = useCallback(async () => {
    // Lógica para obtener la lista de empleados
    try {
      setLoading(true);
      const empleadosData = await getAllEmpleados(search, rowsPerPage, page);
      setEmpleados(empleadosData);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [search, rowsPerPage, page]);

  const getEmpleadoByCUIL = useCallback(async (cuil) => {
    try {
      const empleado = await fetchEmpleadoByCUIL(cuil);
      return empleado;
    } catch (error) {
      setError(error);
    }
  }, []);

  const toggleEmployeeActive = useCallback(async (employee) => {
    const cuil = employee.cuil;

    // Determinar el nuevo estado y el mensaje de acción
    const isCurrentlyActive = employee.activo === 1;
    const newStatus = isCurrentlyActive ? 0 : 1; // 0: baja, 1: activo
    const actionMessage = isCurrentlyActive ? "baja" : "activación";

    // Preparar los datos según el estado (la fecha de baja solo se envía al dar de baja)
    const dataToSend = {
      activo: newStatus,
      fecha_baja: isCurrentlyActive
        ? new Date().toISOString().split("T")[0]
        : null,
      // Al reactivar conservamos la fecha_ingreso original del empleado, sin sobreescribirla
      fecha_ingreso: moment(employee.fecha_ingreso).format("YYYY-MM-DD"),
    };

    try {
      const result = await updateEstado(cuil, dataToSend);

      if (result.message) {
        showToast(`Empleado dado de ${actionMessage} con éxito.`, "success");

        // 🚨 CLAVE: Recargar todos los datos desde la API para refrescar la tabla
        await getEmpleados();
      } else if (result.error) {
        showToast(result.error, "error");
      }
    } catch (error) {
      showToast(
        `Error de conexión o servidor al intentar la ${actionMessage}.`,
        "error"
      );
    }
  }, [getEmpleados, showToast]);

  return {
    empleados: empleados,
    getEmpleadoByCUIL,
    getEmpleados,
    deactivateEmployee: toggleEmployeeActive,
    Toast,
    error,
    loading,
  };
};
